module.exports = __webpack_public_path__ + "img/4-5.b2b265f5.svg";